function lsTest () {
  var test = '987654321';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

function ssTest () {
  var test = '987654321';
  try {
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

export function setLocal (key, val) {
  if (!lsTest()) return null;
  localStorage.setItem(key, JSON.stringify({
    tstamp: new Date(),
    value: val
  }));
  return val;
}

export function getLocal (key, maxAgeMinutes = null) {
  if (!lsTest()) return null;
  var v = localStorage.getItem(key);
  if (v) {
    v = JSON.parse(v);
    if (maxAgeMinutes !== null && typeof maxAgeMinutes === 'number') {
      v.tstamp = new Date(v.tstamp);
      var ageMinutes = (Math.abs(new Date() - v.tstamp) / 1000) / 60;
      if (ageMinutes > maxAgeMinutes) {
        return null;
      }
    }
    return v.value;
  } else {
    return null;
  }
}

export function setSession (key, val) {
  if (!ssTest()) return null;
  sessionStorage.setItem(key, JSON.stringify({
    tstamp: new Date(),
    value: val
  }));
  return val;
}

export function getSession (key, maxAgeMinutes = null) {
  if (!ssTest()) return null;
  var v = sessionStorage.getItem(key);
  if (v) {
    v = JSON.parse(v);
    if (maxAgeMinutes !== null && typeof maxAgeMinutes === 'number') {
      v.tstamp = new Date(v.tstamp);
      var ageMinutes = (Math.abs(new Date() - v.tstamp) / 1000) / 60;
      if (ageMinutes > maxAgeMinutes) {
        return null;
      }
    }
    return v.value;
  } else {
    return null;
  }
}

export function setCookie (key, value, maxDays = null) {
  let expiresString = '';
  if (maxDays !== null) {
    let currentDate = new Date();
    let expiresDate = new Date();
    expiresDate.setDate(currentDate.getDate() + maxDays);
    expiresString = `; expires=${expiresDate.toUTCString()};`;
  }
  document.cookie = `${key}=${value}${expiresString}`;
}

export function getCookie (key) {
  // Add the = sign
  key = key + '=';

  // Get the decoded cookie
  const decodedCookie = decodeURIComponent(document.cookie);

  // Get all cookies, split on ; sign
  const cookies = decodedCookie.split(';');

  // Loop over the cookies
  for (let i = 0; i < cookies.length; i++) {
    // Define the single cookie, and remove whitespace
    const cookie = cookies[i].trim();

    // If this cookie has the name of what we are searching
    if (cookie.indexOf(key) === 0) {
      // Return everything after the cookies name
      return cookie.substring(key.length, cookie.length);
    }
  }
}
